import { makeStateKey, TransferState } from '@angular/core';
import { Observable, of } from 'rxjs';

import { TranslateLoader } from '@ngx-translate/core';

export class TranslateServerLoader implements TranslateLoader {
  constructor(
    private transferState: TransferState,
    private basePath = 'shared/options'
  ) {}

  getTranslation(lang: string): Observable<any> {
    const { readFileSync } = require('fs');
    const { join } = require('path');

    const filePath = join(
      process.cwd(),
      this.basePath,
      lang,
      'translations',
      'ang.json'
    );

    try {
      const json = JSON.parse(readFileSync(filePath, 'utf-8'));

      this.transferState.set(makeStateKey(`translation-${lang}`), json);

      return of(json);
    } catch {
      console.error('[SSG translate loader] File not found', filePath);

      return of({});
    }
  }
}

